/**
 * @typedef {object} ViewByMatchState
 * @property {number} activeIndex
 * @property {string} matchId
 */
